import React from 'react';
import clsx from 'clsx';
import { isNil } from 'lodash-es';
import { AText, Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import { IGameTotalSeatsProps } from '../types';

import styles from './index.module.css';

const GameTotalSeats: React.FC<IGameTotalSeatsProps> = ({
  tags = [],
  showTags,
  totalSeatedPlayers,
  isGameCardMinimised
}) => {
  return isNil(totalSeatedPlayers) ? null : (
    <Box
      align="center"
      className={clsx([
        styles.totalSeats,
        showTags &&
          tags.length &&
          tags.length > 1 &&
          styles.totalSeatsUnderTwoTags,
        showTags &&
          tags.length &&
          tags.length <= 1 &&
          (isGameCardMinimised
            ? styles.totalSeatsUnderTagsMinimisedGameCard
            : styles.totalSeatsUnderTags)
      ])}
    >
      <Icon
        size="s"
        name="icons/user_menu/profile_desktop"
        className={styles.icon}
      />
      <AText size="xs" breed="B">
        {totalSeatedPlayers}
      </AText>
    </Box>
  );
};

export default GameTotalSeats;
